import { defineComponent as _defineComponent } from 'vue'
import { fillDates } from '../helpers/fillDates';
import { TradeCommissionsReport } from 'ah-api-gateways';
import VChart from './VChart.vue';
import { makeTimeLineChartOptions, makeTimeLineChartDataset } from '../helpers/chartConfig';
import { differenceInDays, differenceInMonths, startOfDay } from 'date-fns';
import { dataColorPrimary, linesColorPrimary } from '../helpers/graphColors';
import { ScaleOptions } from 'chart.js';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, reactive, watch } from 'vue';
import { useReportsState } from 'ah-reports';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionCountReportChart',
  props: {
    fromDate: null,
    toDate: null,
    currency: { default: 'GBP' },
    partnerId: null
  },
  setup(__props: any) {

const props = __props as { fromDate: Date, toDate: Date, currency: string, partnerId?: string };

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

function onRetryFromParentManager(k: string) {
  if (k === 'loadData') {
    loadDates();
  }
}



const state = reactive({
  report: null as TradeCommissionsReport | null,
  options: makeTimeLineChartOptions({ color: linesColorPrimary }),
  data: makeTimeLineChartDataset({ label: 'Transaction Volume', color: dataColorPrimary }),
});

const callbacks = state.options.plugins?.tooltip?.callbacks;

if (callbacks) {
  callbacks.label = (item) => {
    return `${props.currency} ${item.parsed.y}`;
  };
}

const dates = computed(() => ({
  from: props.fromDate,
  to: props.toDate,
}));

const reportsState = useReportsState();

function loadDates() {
  requestManager.manager
    .cancelAndNew(
      'loadData',
      reportsState.services.trade.getTradeCommissionsReport(props.fromDate, props.toDate, props.partnerId)
    )
    .subscribe((response) => {
      state.data.datasets![0].data! = fillDates(
        response.dailyReports.map((i) => ({
          x: startOfDay(new Date(i.date)),
          y: i.tradedAmount,
        })),
        startOfDay(props.fromDate),
        startOfDay(props.toDate)
      );
      const timeRange = differenceInDays(props.toDate, props.fromDate);
      let unit: 'day' | 'month' | 'week' = 'day';
      if (timeRange > 10) {
        unit = timeRange > 60 ? 'month' : 'week';
      }
      const xScale: ScaleOptions<'time'> = state.options.scales?.x as any;
      if (xScale && xScale.time) {
        xScale.time.unit = unit;

        xScale.ticks = {
          minRotation: differenceInMonths(props.fromDate, props.toDate) === -1 ? 13 : 0,
        };
      }

      // Force update by replacing prop reference entirely
      state.options = { ...state.options };
      state.data = { ...state.data };

      state.report = response;
    });
}

watch(dates, loadDates, { immediate: true });

return { __sfc: true,requestManager, onRetryFromParentManager, props, state, callbacks, dates, reportsState, loadDates, VChart, formatCurrencyValue }
}

})